var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCameraRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "19px",
    viewBox: "0 0 27 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messenger---back-to-message-thread",
    transform: "translate(-306.000000, -81.000000)",
    fill: "#FF3D00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.412219,81.5490263 C332.281659,81.4996347 332.156113,81.4748349 332.035475,81.4748349 C331.764224,81.4748349 331.538462,81.5690428 331.357505,81.7569388 L325.285488,87.7242719 L325.285488,85.2750741 C325.285488,84.0973192 324.861091,83.0905631 324.012296,82.2542858 C323.163449,81.4181126 322.141665,81 320.946102,81 L310.339175,81 C309.143981,81 308.121881,81.4181126 307.272981,82.2542858 C306.424397,83.0905631 306,84.0973192 306,85.2750741 L306,95.7250819 C306,96.9027328 306.424397,97.9094369 307.273034,98.7456622 C308.121934,99.5818874 309.144034,100 310.339228,100 L320.946207,100 C322.141718,100 323.163554,99.5818874 324.012402,98.7456622 C324.861196,97.9094369 325.285594,96.9027848 325.285594,95.7250819 L325.285594,93.2608586 L331.357611,99.2430092 C331.538568,99.4308532 331.764329,99.5250091 332.03558,99.5250091 C332.156219,99.5250091 332.281765,99.5002613 332.412324,99.4509737 C332.804266,99.2826785 333,98.9908523 333,98.5752353 L333,82.4250247 C332.999842,82.0091997 332.804108,81.7173215 332.412219,81.5490263 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCameraRed);
export default __webpack_public_path__ + "static/media/icCameraRed.bf033f33bdf517e73b6d2fce95afd322.svg";
export { ForwardRef as ReactComponent };